import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TailoringForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    customerName: '',
    phone: '',
    fileNumber: '',
    quantity: '1',
    fabricCode: '',
    model: '',
    collarType: '',
    buttonOpening: '',
    topPocket: '',
    sidePocket: '',
  });

  const models = [
    { 
      name: 'حجازي', 
      price: 100,
      image: 'https://public.readdy.ai/ai/img_res/67e16fef61555199af684935fc788b24.jpg'
    },
    { 
      name: 'غزاوي', 
      price: 100,
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Ghazawi%20style%20thobe%20white%20elegant%20Palestinian%20formal%20garment%20with%20unique%20design%20clean%20simple%20background%20professional%20product%20photography&width=300&height=400&seq=ghazawi-model-001&orientation=portrait'
    },
    { 
      name: 'كويتي', 
      price: 100,
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Kuwaiti%20style%20thobe%20white%20elegant%20Gulf%20formal%20garment%20with%20classic%20design%20clean%20simple%20background%20professional%20product%20photography&width=300&height=400&seq=kuwaiti-model-001&orientation=portrait'
    },
    { 
      name: 'موديلات أخرى', 
      priceRange: '120 - 150',
      image: 'https://readdy.ai/api/search-image?query=Modern%20custom%20style%20thobe%20white%20elegant%20contemporary%20Arabic%20formal%20garment%20with%20special%20design%20clean%20simple%20background%20professional%20product%20photography&width=300&height=400&seq=custom-model-001&orientation=portrait'
    },
  ];

  const collarTypes = [
    { name: 'ياقة عادية', image: 'https://readdy.ai/api/search-image?query=Standard%20collar%20thobe%20neckline%20close%20up%20detail%20white%20fabric%20classic%20design%20clean%20background%20professional%20product%20detail%20photography&width=200&height=200&seq=collar-standard-001&orientation=squarish' },
    { name: 'ياقة مفتوحة', image: 'https://readdy.ai/api/search-image?query=Open%20collar%20thobe%20neckline%20close%20up%20detail%20white%20fabric%20modern%20design%20clean%20background%20professional%20product%20detail%20photography&width=200&height=200&seq=collar-open-001&orientation=squarish' },
    { name: 'ياقة صينية', image: 'https://readdy.ai/api/search-image?query=Mandarin%20collar%20thobe%20neckline%20close%20up%20detail%20white%20fabric%20elegant%20design%20clean%20background%20professional%20product%20detail%20photography&width=200&height=200&seq=collar-mandarin-001&orientation=squarish' },
  ];

  const buttonOpenings = [
    { name: 'فتحة كاملة', image: 'https://readdy.ai/api/search-image?query=Full%20button%20opening%20thobe%20front%20detail%20white%20fabric%20buttons%20from%20top%20to%20bottom%20clean%20background%20professional%20product%20detail%20photography&width=200&height=200&seq=button-full-001&orientation=squarish' },
    { name: 'فتحة نصفية', image: 'https://readdy.ai/api/search-image?query=Half%20button%20opening%20thobe%20front%20detail%20white%20fabric%20buttons%20partial%20length%20clean%20background%20professional%20product%20detail%20photography&width=200&height=200&seq=button-half-001&orientation=squarish' },
    { name: 'فتحة قصيرة', image: 'https://readdy.ai/api/search-image?query=Short%20button%20opening%20thobe%20front%20detail%20white%20fabric%20minimal%20buttons%20clean%20background%20professional%20product%20detail%20photography&width=200&height=200&seq=button-short-001&orientation=squarish' },
  ];

  const topPockets = [
    { name: 'جيب مربع', image: 'https://readdy.ai/api/search-image?query=Square%20chest%20pocket%20thobe%20detail%20white%20fabric%20classic%20design%20clean%20background%20professional%20product%20detail%20photography&width=200&height=200&seq=pocket-square-001&orientation=squarish' },
    { name: 'جيب مثلث', image: 'https://readdy.ai/api/search-image?query=Triangle%20chest%20pocket%20thobe%20detail%20white%20fabric%20modern%20design%20clean%20background%20professional%20product%20detail%20photography&width=200&height=200&seq=pocket-triangle-001&orientation=squarish' },
    { name: 'بدون جيب', image: 'https://readdy.ai/api/search-image?query=No%20chest%20pocket%20thobe%20detail%20white%20fabric%20clean%20minimal%20design%20simple%20background%20professional%20product%20detail%20photography&width=200&height=200&seq=pocket-none-001&orientation=squarish' },
  ];

  const sidePockets = [
    { name: 'جيب عادي', image: 'https://readdy.ai/api/search-image?query=Standard%20side%20pocket%20thobe%20detail%20white%20fabric%20classic%20design%20clean%20background%20professional%20product%20detail%20photography&width=200&height=200&seq=side-standard-001&orientation=squarish' },
    { name: 'جيب مخفي', image: 'https://readdy.ai/api/search-image?query=Hidden%20side%20pocket%20thobe%20detail%20white%20fabric%20invisible%20design%20clean%20background%20professional%20product%20detail%20photography&width=200&height=200&seq=side-hidden-001&orientation=squarish' },
    { name: 'جيب بسحاب', image: 'https://readdy.ai/api/search-image?query=Zipper%20side%20pocket%20thobe%20detail%20white%20fabric%20modern%20secure%20design%20clean%20background%20professional%20product%20detail%20photography&width=200&height=200&seq=side-zipper-001&orientation=squarish' },
  ];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Save form data to localStorage
    localStorage.setItem('tailoringStep1', JSON.stringify(formData));
    
    // Navigate to step 2 (measurements page)
    navigate('/tailoring/step2');
  };

  return (
    <section className="py-16 bg-primary">
      <div className="container mx-auto px-6 max-w-5xl">
        <form onSubmit={handleSubmit} className="bg-white rounded-3xl p-8 shadow-sm">
          <div className="space-y-8">
            {/* Customer Name */}
            <div>
              <label className="block text-accent font-medium mb-2">
                اسم العميل <span className="text-secondary">*</span>
              </label>
              <input
                type="text"
                name="customerName"
                value={formData.customerName}
                onChange={handleChange}
                required
                placeholder="أدخل اسم العميل"
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-secondary text-accent"
              />
            </div>

            {/* Phone */}
            <div>
              <label className="block text-accent font-medium mb-2">
                رقم الجوال <span className="text-secondary">*</span>
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                placeholder="مثال: 96512345678"
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-secondary text-accent"
              />
            </div>

            {/* File Number */}
            <div>
              <label className="block text-accent font-medium mb-2">
                رقم الملف (اختياري)
              </label>
              <input
                type="text"
                name="fileNumber"
                value={formData.fileNumber}
                onChange={handleChange}
                placeholder="أدخل رقم الملف إن وجد"
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-secondary text-accent"
              />
            </div>

            {/* Quantity */}
            <div>
              <label className="block text-accent font-medium mb-2">
                عدد الثياب <span className="text-secondary">*</span>
              </label>
              <input
                type="number"
                name="quantity"
                value={formData.quantity}
                onChange={handleChange}
                required
                min="1"
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-secondary text-accent"
              />
            </div>

            {/* Fabric Code */}
            <div>
              <label className="block text-accent font-medium mb-2">
                اختيار القماش (من صفحة الأقمشة باستخدام الكود)
              </label>
              <input
                type="text"
                name="fabricCode"
                value={formData.fabricCode}
                onChange={handleChange}
                placeholder="أدخل كود القماش"
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-secondary text-accent"
              />
              <p className="text-sm text-gray-500 mt-2">
                يمكنك الحصول على كود القماش من <a href="/fabrics" className="text-secondary hover:underline cursor-pointer">صفحة الأقمشة</a>
              </p>
            </div>

            {/* Model Selection */}
            <div>
              <label className="block text-accent font-medium mb-3">
                اختيار موديل الثوب <span className="text-secondary">*</span>
              </label>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {models.map((model) => (
                  <div
                    key={model.name}
                    onClick={() => setFormData({ ...formData, model: model.name })}
                    className={`rounded-xl border-2 cursor-pointer transition-all overflow-hidden ${
                      formData.model === model.name
                        ? 'border-secondary shadow-lg'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <div className="w-full h-48 bg-gray-100">
                      <img
                        src={model.image}
                        alt={model.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="p-3 text-center bg-white">
                      <p className="text-accent font-bold mb-1">{model.name}</p>
                      <p className="text-sm text-secondary font-medium">
                        {'priceRange' in model ? model.priceRange : model.price} د.ك
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Collar Type */}
            <div>
              <label className="block text-accent font-medium mb-3">
                نوع الياقة <span className="text-secondary">*</span>
              </label>
              <div className="grid grid-cols-3 gap-4">
                {collarTypes.map((collar) => (
                  <div
                    key={collar.name}
                    onClick={() => setFormData({ ...formData, collarType: collar.name })}
                    className={`rounded-xl border-2 cursor-pointer transition-all overflow-hidden ${
                      formData.collarType === collar.name
                        ? 'border-secondary shadow-lg'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <div className="w-full h-32 bg-gray-100">
                      <img
                        src={collar.image}
                        alt={collar.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="p-3 text-center bg-white">
                      <p className="text-accent font-medium text-sm">{collar.name}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Button Opening */}
            <div>
              <label className="block text-accent font-medium mb-3">
                نوع فتحة الأزرار <span className="text-secondary">*</span>
              </label>
              <div className="grid grid-cols-3 gap-4">
                {buttonOpenings.map((button) => (
                  <div
                    key={button.name}
                    onClick={() => setFormData({ ...formData, buttonOpening: button.name })}
                    className={`rounded-xl border-2 cursor-pointer transition-all overflow-hidden ${
                      formData.buttonOpening === button.name
                        ? 'border-secondary shadow-lg'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <div className="w-full h-32 bg-gray-100">
                      <img
                        src={button.image}
                        alt={button.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="p-3 text-center bg-white">
                      <p className="text-accent font-medium text-sm">{button.name}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Top Pocket */}
            <div>
              <label className="block text-accent font-medium mb-3">
                شكل الجيب العلوي <span className="text-secondary">*</span>
              </label>
              <div className="grid grid-cols-3 gap-4">
                {topPockets.map((pocket) => (
                  <div
                    key={pocket.name}
                    onClick={() => setFormData({ ...formData, topPocket: pocket.name })}
                    className={`rounded-xl border-2 cursor-pointer transition-all overflow-hidden ${
                      formData.topPocket === pocket.name
                        ? 'border-secondary shadow-lg'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <div className="w-full h-32 bg-gray-100">
                      <img
                        src={pocket.image}
                        alt={pocket.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="p-3 text-center bg-white">
                      <p className="text-accent font-medium text-sm">{pocket.name}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Side Pocket */}
            <div>
              <label className="block text-accent font-medium mb-3">
                شكل الجيب الجانبي <span className="text-secondary">*</span>
              </label>
              <div className="grid grid-cols-3 gap-4">
                {sidePockets.map((pocket) => (
                  <div
                    key={pocket.name}
                    onClick={() => setFormData({ ...formData, sidePocket: pocket.name })}
                    className={`rounded-xl border-2 cursor-pointer transition-all overflow-hidden ${
                      formData.sidePocket === pocket.name
                        ? 'border-secondary shadow-lg'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <div className="w-full h-32 bg-gray-100">
                      <img
                        src={pocket.image}
                        alt={pocket.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="p-3 text-center bg-white">
                      <p className="text-accent font-medium text-sm">{pocket.name}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={
                !formData.customerName ||
                !formData.phone ||
                !formData.model ||
                !formData.collarType ||
                !formData.buttonOpening ||
                !formData.topPocket ||
                !formData.sidePocket
              }
              className="w-full bg-secondary text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-opacity-90 transition-all cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
            >
              الانتقال إلى صفحة المقاسات
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default TailoringForm;
